// Pill styling for StatusChip (renders both NrtStatus and NrtTestStatus).

// Hex-alpha tint only works on #rrggbb; other formats skip it.
const isSixDigitHex = (color: string) => /^#[0-9a-f]{6}$/i.test(color);

export const buildChipSx = (color: string) => ({
  // Fallback for older browsers without color-mix() support.
  ...(isSixDigitHex(color) && { backgroundColor: `${color}26` }),
  "@supports (background-color: color-mix(in srgb, red 15%, white))": {
    backgroundColor: `color-mix(in srgb, ${color} 15%, white)`
  },
  borderRadius: "999px",
  display: "inline-block",
  padding: "0.15rem 0.75rem"
});
